import flipPage from './App.vue'

export default flipPage
